module.exports = __webpack_public_path__ + "static/media/new-midwestjs-optimized.eb612ecb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/98-demo/images/new-midwestjs-optimized.jpg
// module id = 978
// module chunks = 0